import { createContext, useContext } from "react";
import useQuote from "../hooks/useQuote";

const QuoteContext = createContext(null);

export function QuoteProvider({ children }) {
  const quote = useQuote();
  return (
    <QuoteContext.Provider value={quote}>
      {children}
    </QuoteContext.Provider>
  );
}

export function useQuoteContext() {
  const ctx = useContext(QuoteContext);
  if (!ctx) {
    throw new Error("useQuoteContext must be used within a QuoteProvider");
  }
  return ctx;
}
